"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Upload',
  /**
   * 使用示例   <upload name="tutorialsSharePic" :img-url="ruleForm.tutorialsSharePic" @pictureAddress="onPictureAddress($event)" />
   * marketingFunction/GiftSubsidy/marketingEvents页面
   * name 回传出去的赋值字段
   * imgUrl 回显的url地址
   */
  props: {
    name: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imageUrl: this.imgUrl
    };
  },
  watch: {
    imgUrl: function imgUrl(newVal) {
      // 当 imgUrl 发生变化时，更新 imageUrl
      this.imageUrl = newVal;
    }
  },
  methods: {
    // handleAvatarSuccess(res, file) {
    //   this.imageUrl = URL.createObjectURL(file.raw)
    // },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      // console.log('类型')

      // const isJPG = file.type === 'image/jpeg'
      // const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.imageUrl = pictureUrl;
              this.$emit('pictureAddress', {
                pictureUrl: pictureUrl,
                name: this.name
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }()
  }
};